import React, { useEffect } from "react";
import { withMonogramContext } from "./MonogramContext";
import MonogramSettingHeader from "./MonogramSettingHeader";
import clsx from "clsx";
import { getRegexForAllowedCharacters, trimStringWithException } from "./util";

const MonogramTextInput = ({
  textValue,
  setTextValue,
  setPreviousTextValue,
  maxLength,
  allowSpecialCharacters = true,
  errors,
  validate,
  language,
  chosenFont,
  initialPageLoad,
}) => {
  const handleChange = (e) => {
    const {
      special_character,
      max_special_characters,
      allowed_characters,
      allowed_special_characters,
    } = chosenFont;
    const useSpecialCharacters = special_character && max_special_characters > 0;

    const allowedCharacterRegex = getRegexForAllowedCharacters(
      allowed_characters,
      special_character,
      allowed_special_characters
    );

    let inputValue = allowedCharacterRegex
      ? e.target.value.replace(allowedCharacterRegex, "")
      : e.target.value;

    inputValue = useSpecialCharacters
      ? trimStringWithException(inputValue, maxLength, special_character, max_special_characters)
      : inputValue.slice(0, maxLength);

    if (allowSpecialCharacters) {
      setPreviousTextValue(textValue);
      setTextValue(inputValue);
    } else {
      const regex = /^[a-zA-Z]*$/;
      if (regex.test(inputValue)) {
        setPreviousTextValue(textValue);
        setTextValue(inputValue);
      }
    }
  };

  useEffect(() => {
    handleChange({ target: { value: textValue } });
  }, [chosenFont]);

  const title = maxLength === 3 ? chosenFont?.font_initials_title : chosenFont?.font_words_title;
  const subtitle =
    maxLength === 3 ? chosenFont?.font_initials_subtitle : chosenFont?.font_words_subtitle;
  const inputText = "Enter Text (Number of Characters depends on Font Selection)";

  return (
    <div className="monogram-setting-input-wrapper">
      <MonogramSettingHeader
        title={title || language.enter_text}
        subtitle={subtitle || language.enter_text_subtitle.replace("{{ max }}", maxLength)}
      />
      <input
        type="text"
        aria-label={inputText}
        placeholder={title || language.enter_text}
        value={textValue}
        onChange={handleChange}
        className={clsx(errors.textValue && "input-error")}
      />
    </div>
  );
};

export default withMonogramContext(MonogramTextInput);
